import { tv } from "../../variants/tv.js";
const overlaySearchHeaderVariants = tv({
    slots: {
        root: 'px-4 py-4'
    }
});
export { overlaySearchHeaderVariants };
